import {
  FARB_ABHOLUNG,
  FARB_ERFASST,
  kategorisiereAbholung,
  kategorisiereAlter
} from '@/lib/altersFarben';
import { datumDe, datumZeitDe, formatTageBis, formatTageSeit } from '@/lib/format';

type Props = {
  tage: number;
  modus: 'seit' | 'bis';
  datum: string;
};

export function AgeIndicator({ tage, modus, datum }: Props) {
  const farbe =
    modus === 'bis' ? FARB_ABHOLUNG[kategorisiereAbholung(tage)] : FARB_ERFASST[kategorisiereAlter(tage)];
  const text = modus === 'bis' ? formatTageBis(tage) : formatTageSeit(tage);
  // Der Tooltip nannte bisher in beiden Modi "zugesagt" — in der Spalte
  // "Erfasst" steht dort aber das Erfassungsdatum. Und erfasst_am ist ein
  // Zeitstempel, kein Kalendertag (B72).
  const tooltip =
    modus === 'bis' ? `zugesagt: ${datumDe(datum)}` : `erfasst: ${datumZeitDe(datum)}`;
  return (
    <span
      // `whitespace-nowrap` (A10.1): "vor 12 Tagen" brach in der
      // Erfasst-Spalte um und machte die Zelle 40 statt 20 px hoch —
      // das hob jede Tabellenzeile mit an. Passt es nicht, wird
      // abgeschnitten statt umbrochen; das Datum steht in der Bestellung.
      className="inline-flex items-center gap-2 whitespace-nowrap text-sm"
      style={{ color: farbe }}
      title={tooltip}
    >
      <span aria-hidden className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: farbe }} />
      {text}
    </span>
  );
}
